import { render, staticRenderFns } from "./institucion-actual.vue?vue&type=template&id=62f91dbc&scoped=true&"
import script from "./institucion-actual.component.ts?vue&type=script&lang=ts&"
export * from "./institucion-actual.component.ts?vue&type=script&lang=ts&"
import style0 from "./institucion-actual.vue?vue&type=style&index=0&id=62f91dbc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62f91dbc",
  null
  
)

export default component.exports